import { toast } from 'react-toastify';
import * as constants from '../constants/constants';
import { apiCaller, axiosCaller } from "../utils/apiCaller";
import { ACTION, wrap, setLoading, setButtonLoading }  from './generalActions'
import client from "../reducers/client";
import {Project} from "../types/Project.type";
import {translatedText} from "../components/TranslatedText"


export const setEmail = (payload: string): ACTION => ({
    type: constants.SET_EMAIL,
    payload
});

export const setUserToDelete = (payload: number): ACTION => ({
    type: constants.SET_USER_TO_DELETE,
    payload
});

export const setDeletedState = (payload: boolean): ACTION => ({
    type: constants.SET_DELETED_STATE,
    payload
});

export const resetClient = (payload: any): ACTION => ({
    type: constants.RESET_CLIENT,
    payload
});

export const createClient = (payload: Object, letter: string, fromDate?: Date, toDate?: Date, currentPage?: number) => wrap((dispatch:any, state:any) => {
    try {
        const headers = {
            "Accept": "multipart/form-data",
            "Content-Type": "multipart/form-data"
        }
        return axiosCaller('POST', `clients`, payload, headers, true).then((response:any) => {
            if (response?.data?.unique) {
                toast.error(translatedText({id:"clientExists",defaultMessage:"Ky klient ekziston!"}));
                return {}
            }
            if(response.data.data){
                dispatch({ "type": constants.CREATE_CLIENT, payload: response.data.data })
            }
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            return response
        });
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        throw new Error(err.message);
    }
}, 'CREATE_CLIENT_ERROR');

export const editClient = (id:number, payload:any) => wrap((dispatch:any, state:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return axiosCaller('POST', `clients/${id}?_method=PATCH`, payload).then((response:any) => {
            dispatch({ "type": constants.EDIT_CLIENT, payload: response })
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            return response
        });
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        throw new Error('Diqka nuk shkoi mire');
    }
}, 'EDIT_CLIENT_ERROR');


export const fetchClient = (clientId: number, moduleId:number) => wrap(async(dispatch:any) => {
    try {
        // dispatch(setLoading(true))
        // dispatch(setButtonLoading(true));Dont setLoader to true for this request
        return await apiCaller('GET', `clients/${clientId}`).then(res => {
            dispatch({ "type": constants.FETCHED_CLIENT, "payload": res });
            // dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            return res
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        throw new Error('Diqka nuk shkoi mire');
    }
}, 'GET_CLIENT_ERROR')


export const fetchClients = (start?, end?, search?) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        //add date on get request api url
        let url = 'clients/search';
        const params = [];
        if (start && end) {
            params.push(`start=${start}`, `end=${end}`);
        }
        if (search) {
            params.push(`search=${encodeURIComponent(search)}`);
        }
        if (params.length > 0) {
            url += '?' + params.join('&');
        }
        return await apiCaller('GET', url).then(res => {
            dispatch({ "type": constants.FETCHED_CLIENTS, "payload": res });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            return res
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'GET_CLIENTS_ERROR')

export const getAllClients = (page = 1, perPage = 20, search = '', createdFrom = '', userId = '', createdTo = '', projectFilter = '') => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));

        let url = `clients?page=${page}&per_page=${perPage}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        if (createdFrom) {
            url += `&created_from=${encodeURIComponent(createdFrom)}`;
        }
        if (createdTo) {
            url += `&created_to=${encodeURIComponent(createdTo)}`;
        }
        if (userId) {
            url += `&user_id=${encodeURIComponent(userId)}`;
        }
        if (projectFilter) {
            url += `&project_filter=${encodeURIComponent(projectFilter)}`;
        }

        return await apiCaller('GET', url).then((res: any) => {
            dispatch({ "type": constants.FETCHED_CLIENTS, "payload": res });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            return res
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'GET_CLIENTS_ERROR')

export const getClientsWithoutInstallation = (page = 1, perPage = 20, search = '') => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));

        let url = `clients/without-installation?page=${page}&per_page=${perPage}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }

        return await apiCaller('GET', url).then((res: any) => {
            dispatch({ "type": constants.FETCHED_CLIENTS, "payload": res });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            return res
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'GET_CLIENTS_ERROR')

export const getClientDashboardStats = () => wrap(async(dispatch:any) => {
    try {
        return await apiCaller('GET', 'clients/dashboard-stats').then((res: any) => {
            return res
        })
    } catch(err) {
        // silent fail — stats are non-critical
    }
}, 'GET_DASHBOARD_STATS_ERROR')

export const getArchiveDashboardStats = () => wrap(async(dispatch:any) => {
    try {
        return await apiCaller('GET', 'archive/contact/dashboard-stats').then((res: any) => {
            return res
        })
    } catch(err) {
        // silent fail
    }
}, 'GET_ARCHIVE_STATS_ERROR')

export const deleteClient = (clientId:any, note?: string) => wrap((dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        // DELETE with a body — apiCaller routes through fetch which honours the
        // `body` field on DELETE requests. The note is optional; when undefined
        // it's omitted entirely so the backend treats it as null.
        const body = note ? JSON.stringify({ note }) : undefined;
        return apiCaller('DELETE', `clients/${clientId}`, body).then((res:any) => {
            dispatch({"type": constants.DELETE_CLIENT, "payload": res})
            // Backend now returns { data: bool, reason?: string, blocking_projects?: [...] }.
            // apiCaller unwraps the body, so res.data is the bool, res.reason is the string,
            // res.blocking_projects is the array. On failure we surface exactly WHY.
            if (res?.data === true) {
                toast.success(translatedText({id:"clientDeleted",defaultMessage:"Klienti u fshi me sukses"}))
            } else if (res?.reason === 'projects_blocked') {
                const blocking = Array.isArray(res?.blocking_projects) ? res.blocking_projects : []
                const names = blocking.map((p: any) => `"${p.name || '?'}"`).join(', ')
                const productCount = blocking.reduce((sum: number, p: any) => sum + (Number(p.blocking_product_count) || 0), 0)
                const template = translatedText({
                    id: 'clientCannotDelete.productsInProduction',
                    defaultMessage: 'Nuk mund të fshihet ky klient — projektet {names} kanë {count} produkte në prodhim. Mbaroni ose anuloni produktet në prodhim para se ta fshini klientin.',
                })
                toast.error(template.replace('{names}', names).replace('{count}', String(productCount)))
            } else if (res?.reason === 'unauthorized') {
                toast.error(translatedText({id:"clientCannotDelete.unauthorized",defaultMessage:"Nuk keni leje për ta fshirë këtë klient."}))
            } else {
                toast.error(translatedText({id:"clientCannotDelete",defaultMessage:"Ky klient nuk mund te fshihet"}))
            }
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        throw new Error('Diqka nuk shkoi mire')
    }
}, 'DELETE_CLIENT_ERROR')


export const exportClients = (letter: string, fromDate?: any, toDate?: any) => wrap(async(dispatch:any) => {
    try {
        
        return await apiCaller('GET', `clients/export-excel?from_date=${fromDate}&to_date=${toDate}&letter=${letter}`).then(res => {
            
            return res
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        
    }
}, 'EXPORT_CLIENTS_ERROR')

export const importClients = (payload:any) => wrap((dispatch:any) => {
    try {
        const headers = {
            "Accept": "multipart/form-data",
            "Content-Type": "multipart/form-data"
        }
        return axiosCaller('POST', 'clients/import-excel', payload, headers, true).then((response:any) => {
            dispatch({ "type": constants.IMPORT_CLIENTS, "payload": response });
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        
        throw new Error('Diqka nuk shkoi mire');
    }
}, 'IMPORT_CLIENTS_ERROR')

export const getClientProjects = (clientId: number, customFilter) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('GET', `clients/${clientId}/projects${customFilter? '?customFilter=projectsWithoutMeasure':''}`).then((response) => {
            dispatch({ "type": constants.GET_CLIENT_PROJECTS, "payload": response.data?.data[0]?.projects });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'GET_CLIENT_PROJECTS')

export const saveClientProjects = (payload) => wrap(async (dispatch: any) => {
    try {
        dispatch({ "type": constants.GET_CLIENT_PROJECTS, "payload": payload });
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'GET_CLIENT_PROJECTS')

export const createProjects = (payload) => wrap(async (dispatch: any) => {
    try {
        return await axiosCaller('POST', `projects`, payload).then((response) => {
            return response
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'GET_CLIENT_PROJECTS')

export const editProject = (projectId, payload) => wrap(async (dispatch: any) => {
    try {
        return await axiosCaller('POST', `projects/${projectId}`, payload).then((response) => {
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
    }
}, 'GET_CLIENT_PROJECTS')

export const deleteProject = (projectId, note?: string) => wrap(async (dispatch: any) => {
    try {
        // axiosCaller now supports DELETE-with-body via the `data` param — used
        // to pass the operator's optional note for the audit trail.
        const body = note ? { note } : undefined;
        return await axiosCaller('DELETE', `projects/${projectId}`, body)
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi gabim!"}));
    }
}, 'GET_CLIENT_PROJECTS')